export const CUSTOM_EVENTS_GROUP = 'custom-behavioral-event';
export const INTEGRATOR_EVENTS_GROUP = 'integrator-event';
export const WEBHOOK_EVENTS_GROUP = 'webhook';